import * as z from 'zod'

/**
 * Typed environment
 *
 * If you want to know if you're a prod or a dev build, use `import.meta.env`.
 * Otherwise use this rather than the untyped `import.meta.env` so that your
 * environment is correctly validated.
 */
const ENV_SCHEMA = z.object({
  /** This is the app title */
  VITE_APP_TITLE: z.string().default('Mona Jukebox'),

  VITE_APP_DESCRIPTION: z.string(),
  VITE_APP_API_URL: z.string().url(),

  /** AP Standard Deployment Params */
  VITE_CLIENT: z.string().optional(),
  VITE_PROJECT: z.string().optional(),
  VITE_DEPLOY_ENV: z.string().optional(),

  /** This is the package.json version */
  VITE_APP_VERSION: z.string().optional(),

  /** Override languages settings */
  VITE_APP_DEFAULT_LANGUAGE: z.string().default('en'),
  VITE_APP_LANGUAGES: z
    .string()
    .default('en;en-US;fr;')
    .transform((value) => value.split(';')),
})

class BadEnvironmentError extends Error {
  name = 'Bad Environment Error'
}

/**
 * Returns the build environment, but only the keys we have validated against
 * the Zod schema.
 */
export default (): z.infer<typeof ENV_SCHEMA> => {
  const env = ENV_SCHEMA.safeParse(import.meta.env)

  if (env.success) return env.data

  const message = env.error.errors
    .map((elem) => `${elem.path}: ${elem.message}`)
    .join('\n')

  throw new BadEnvironmentError(message)
}
